import React, { useEffect, useState } from "react"; // useRef removido - no se usa
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import "dayjs/locale/es";

import {
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonItem,
  IonList,
  IonRow,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import CustomToast from "../../components/basicsComponents/CustomToast/CustomToast";
import LoadingBackdrop from "../../components/basicsComponents/LoadingBackdrop/LoadingBackdrop";
import StyledButton from "../../components/basicsComponents/StyledButton/StyledButton";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "./EstudiosPaciente.css";
import useTituloPagina from "../../hooks/tituloPagina";
import { Typography } from "@mui/material";
import parse from "html-react-parser";
import { convertRtfToHtml } from "rtf-to-html-converter";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  Accordion,
  AccordionDetails,
  AccordionGroup,
  AccordionSummary,
  ListItem,
} from "@mui/joy";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import Tooltip from "@mui/material/Tooltip";
// react-pdf 6 usa PDF.js 2.16.105; el query evita reutilizar un worker viejo del cache.
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js?v=${pdfjs.version}`;

const PDF_HEADER = "%PDF-";

const base64ToUint8Array = (base64Value) => {
  const normalizedBase64 = String(base64Value || "")
    .replace(/^data:application\/pdf(?:;[^,]*)?;base64,/i, "")
    .replace(/\s/g, "")
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  if (!normalizedBase64) {
    throw new Error("El informe PDF no contiene datos base64");
  }

  const padding = (4 - (normalizedBase64.length % 4)) % 4;
  const binary = window.atob(
    normalizedBase64.padEnd(normalizedBase64.length + padding, "="),
  );
  const bytes = new Uint8Array(binary.length);

  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }

  return bytes;
};

const hasPdfHeader = (bytes) => {
  const searchLimit = Math.min(bytes.length, 1024);
  for (let offset = 0; offset <= searchLimit - PDF_HEADER.length; offset += 1) {
    let matches = true;
    for (let index = 0; index < PDF_HEADER.length; index += 1) {
      if (bytes[offset + index] !== PDF_HEADER.charCodeAt(index)) {
        matches = false;
        break;
      }
    }
    if (matches) return true;
  }
  return false;
};

const createPdfPayload = (inputBytes, origin) => {
  const bytes = inputBytes instanceof Uint8Array
    ? inputBytes
    : new Uint8Array(inputBytes);

  if (!bytes.length || !hasPdfHeader(bytes)) {
    throw new Error(`La respuesta de ${origin} no es un archivo PDF valido`);
  }

  // Blob y pdf.js reciben copias separadas porque el worker puede transferir el buffer.
  const pdfBlobUrl = URL.createObjectURL(
    new Blob([bytes.slice()], { type: "application/pdf" }),
  );
  const pdfFile = { data: bytes.slice() };

  return { pdfFile, pdfBlobUrl };
};

const buildApiUrl = (baseUrl, path, queryParams = {}) => {
  const query = new URLSearchParams();

  Object.entries(queryParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, String(value));
    }
  });

  return `${baseUrl}${path}?${query.toString()}`;
};

const fetchBlobFromCandidates = async ({
  candidateUrls,
  token,
  debugLabel,
}) => {
  let lastError;

  for (const url of [...new Set(candidateUrls.filter(Boolean))]) {
    try {
      const response = await axios.request({
        url,
        method: "GET",
        responseType: "blob",
        headers: { Authorization: `Bearer ${token}` },
      });

      return response;
    } catch (error) {
      lastError = error;
    }
  }

  throw lastError || new Error(`No se pudo descargar ${debugLabel}`);
};

const fetchJsonFromCandidates = async ({
  candidateUrls,
  token,
  debugLabel,
  defaultData = [],
}) => {
  let lastError;

  for (const url of [...new Set(candidateUrls.filter(Boolean))]) {
    try {
      const response = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response;
    } catch (error) {
      lastError = error;
    }
  }

  return { data: defaultData };
};

export default function EstudiosPaciente() {
  const [usuario, setUsuario] = useState({});
  const [cargando, setCargando] = useState(false);
  const [cargandoEstudios, setCargandoEstudios] = useState(true);
  const [tituloPagina, setTituloPagina] = useState("");
  const [urlAxioPP, setUrlAxio] = useState("");
  const [listadoEstudios, setListadoEstudios] = useState([]);
  const [listadoEstudiosFiltrados, setListadoEstudiosFiltrados] = useState([]);
  // const [estudioSel, setEstudioSel] = useState(-1); // COMENTADO - no se usa en UI
  // const [listadoEstudiosFiltro, setListadoEstudiosFiltro] = useState([]); // COMENTADO - no se usa
  const [estudioPdf, setEstudioPdf] = useState({
    fecha: "",
    nombre: "",
    doc: {},
    ecografiaHtml: "",
    ecografiaPdfUrl: "",
    generandoPdfEcografia: false,
    pdfFile: null,
    pdfBlobUrl: "",
  });
  const [abrirModal, setAbrirModal] = useState(false);

  const [toast, setToast] = useState({ open: false, mensaje: "", tipo: "" });
  const mostrarNotificacion = (abrir, mensaje, tipo) => {
    let notificacion = {};
    if (abrir) {
      notificacion = { open: true, mensaje: mensaje, tipo: tipo };
    } else {
      notificacion = { open: false, mensaje: "", tipo: "" };
    }
    setToast(notificacion);
  };

  const abrirEnNuevaVentana = (src) => {
    if (!src) return;
    window.open(src, "_blank", "noopener,noreferrer");
  };
  const history = useHistory();
  useTituloPagina();

  const abrirModalEstudio = () => setAbrirModal(true);
  const cerrarModalEstudio = () => {
    setAbrirModal(false);
    setNumPages(null);
    setEstudioPdf((prev) => ({
      ...prev,
      ecografiaPdfUrl: "",
      generandoPdfEcografia: false,
      pdfFile: null,
      pdfBlobUrl: "",
    }));
  };

  const cleanQuestionMarks = (text) => {
    if (!text) return text;

    let cleanedText = text;
    cleanedText = cleanedText.replace(
      /([áéíóúàèìòùâêîôûäëïöüñçÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÇ])\?/g,
      "$1",
    );
    cleanedText = cleanedText.replace(/\?\s*\?\s*\?+/g, "<br/>");
    cleanedText = cleanedText.replace(/\?\s*\?/g, "<br/>");
    cleanedText = cleanedText.replace(/\s*\?\s*/g, "<br/>");
    cleanedText = cleanedText.replace(/(<br\/>){3,}/g, "<br/><br/>");
    cleanedText = cleanedText.replace(/<br\/>\s+/g, "<br/>");
    cleanedText = cleanedText.replace(/\s+<br\/>/g, "<br/>");

    return cleanedText;
  };

  const escapeHtml = (text = "") =>
    String(text)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");

  const getRtfHtmlContent = (rtfContent) => {
    if (!rtfContent) return "";

    try {
      const cleanedRtfContent = cleanQuestionMarks(rtfContent);
      const htmlContent = convertRtfToHtml(cleanedRtfContent);

      if (!htmlContent) {
        const cleanedFallback = cleanQuestionMarks(rtfContent);
        return `<pre style="white-space: pre-wrap; font-family: Arial;">${escapeHtml(cleanedFallback)}</pre>`;
      }

      const cleanedHtmlContent = cleanQuestionMarks(htmlContent);
      const bodyRegex = /<body[^>]*>((.|[\n\r])*)<\/body>/im;
      const bodyMatches = cleanedHtmlContent.match(bodyRegex);

      if (bodyMatches && bodyMatches.length > 1) {
        return bodyMatches[1];
      }

      return cleanedHtmlContent;
    } catch (error) {
      console.error("Error converting RTF to HTML:", error);
      let cleanedFallback = rtfContent;
      cleanedFallback = cleanedFallback.replace(
        /([áéíóúàèìòùâêîôûäëïöüñçÁÉÍÓÚÀÈÌÒÙÂÊÎÔÛÄËÏÖÜÑÇ])\?/g,
        "$1",
      );
      cleanedFallback = cleanedFallback.replace(/\?\s*\?\s*\?+/g, "<br/>");
      cleanedFallback = cleanedFallback.replace(/\?\s*\?/g, "<br/>");
      cleanedFallback = cleanedFallback.replace(/\s*\?\s*/g, "<br/>");
      cleanedFallback = cleanedFallback.replace(/(<br\/>){3,}/g, "<br/><br/>");
      cleanedFallback = cleanedFallback.replace(/<br\/>\s+/g, "<br/>");
      cleanedFallback = cleanedFallback.replace(/\s+<br\/>/g, "<br/>");

      return `<div style="font-family: Arial, sans-serif; white-space: normal;">${cleanedFallback}</div>`;
    }
  };

  const parseRtfToHtml = (rtfContent) => {
    const htmlContent = getRtfHtmlContent(rtfContent);
    return htmlContent ? parse(htmlContent) : null;
  };

  const generarPdfDesdeHtmlEcografia = async (htmlContent, titulo, fecha) => {
    if (!htmlContent) return null;

    const escapeForTemplate = (value = "") =>
      String(value)
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");

    const fechaEstudio = fecha || "Sin fecha";
    const fechaGeneracion = dayjs().format("DD/MM/YYYY HH:mm");
    const tituloNormalizado = String(titulo || "Ecografía")
      .replace(/\.[^.]+$/, "")
      .replace(/[_-]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    const numeroEstudio =
      tituloNormalizado.match(/(?:__|_)?(\d+(?:[.,]\d+)?)$/)?.[1] ||
      tituloNormalizado.match(/(\d+(?:[.,]\d+)?)(?!.*\d)/)?.[1] ||
      "--";
    const tituloInforme = tituloNormalizado
      .replace(/(?:__|_)?\d+(?:[.,]\d+)?$/g, "")
      .trim()
      .toUpperCase();
    const nombrePaciente = [usuario?.apellido, usuario?.nombre]
      .filter(Boolean)
      .join(", ")
      .toUpperCase();
    const edadPaciente =
      usuario?.nacimiento && dayjs(usuario.nacimiento).isValid()
        ? `${dayjs().diff(usuario.nacimiento, "year")} AÑOS`
        : "--";
    const coberturaPaciente = (
      usuario?.mutualNombre ||
      usuario?.mutualNom ||
      usuario?.mutual ||
      "PARTICULAR"
    )
      .toString()
      .toUpperCase();
    const medicoSolicitante = (
      usuario?.medicoSolicitante ||
      usuario?.prestadorNom ||
      "--"
    )
      .toString()
      .toUpperCase();

    const container = document.createElement("div");
    container.style.position = "fixed";
    container.style.left = "-10000px";
    container.style.top = "0";
    container.style.width = "794px";
    container.style.background = "#ffffff";
    container.style.padding = "32px";
    container.style.boxSizing = "border-box";
    container.style.color = "#000";
    container.style.fontFamily = "'Times New Roman', Georgia, serif";

    container.innerHTML = `
      <style>
        .ecografia-sheet {
          border: 1px solid #dfe5ee;
          border-radius: 4px;
          padding: 30px 40px 28px;
          background: #fff;
          color: #111827;
          box-sizing: border-box;
          font-family: Arial, sans-serif;
        }
        .ecografia-header {
          min-height: 145px;
          display: flex;
          align-items: flex-start;
          padding-bottom: 8px;
        }
        .ecografia-logo {
          width: 176px;
          height: 130px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .ecografia-logo img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          display: block;
        }
        .ecografia-brand {
          flex: 1;
          min-height: 130px;
        }
        .ecografia-separator {
          height: 2px;
          background: #111827;
          margin: 4px 0 14px;
        }
        .ecografia-grid {
          display: grid;
          grid-template-columns: 1fr 0.78fr;
          column-gap: 24px;
          font-size: 13px;
          color: #111827;
        }
        .ecografia-grid-col {
          display: flex;
          flex-direction: column;
          gap: 3px;
        }
        .ecografia-field-row {
          display: flex;
          gap: 7px;
          align-items: baseline;
          line-height: 1.2;
        }
        .ecografia-field-label {
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.2px;
          white-space: nowrap;
        }
        .ecografia-field-value {
          font-weight: 700;
          text-transform: uppercase;
          word-break: break-word;
        }
        .ecografia-midline {
          height: 2px;
          background: #111827;
          margin-top: 14px;
          margin-bottom: 14px;
        }
        .ecografia-title {
          font-size: 21px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 0.2px;
          color: #111827;
          margin: 0;
        }
        .ecografia-title-underline {
          width: 100%;
          border-top: 2px solid #111827;
          margin: 6px 0 12px;
        }
        .ecografia-content {
          margin-top: 0;
          font-family: Arial, sans-serif;
          font-size: 16.1px;
          line-height: 1.3;
          color: #111827;
          text-align: left;
          word-break: break-word;
        }
        .ecografia-content p {
          margin: 0 0 8px;
        }
        .ecografia-content strong,
        .ecografia-content b {
          font-weight: 800;
        }
        .ecografia-content u {
          text-decoration-thickness: 2px;
        }
        .ecografia-footer {
          margin-top: 24px;
          border-top: 1px solid #cbd5e1;
          padding-top: 8px;
          font-size: 10px;
          color: #64748b;
          display: flex;
          justify-content: space-between;
          gap: 10px;
        }
      </style>
      <div class="ecografia-sheet">
        <div class="ecografia-header">
          <div class="ecografia-logo">
            <img src="assets/icon/logo.jpg" alt="Logo" onerror="this.onerror=null;this.src='assets/icon/logo_cgap.png';" />
          </div>
          <div class="ecografia-brand"></div>
        </div>
        <div class="ecografia-separator"></div>
        <div class="ecografia-grid">
          <div class="ecografia-grid-col">
            <div class="ecografia-field-row">
              <span class="ecografia-field-label">Paciente:</span>
              <span class="ecografia-field-value">${escapeForTemplate(nombrePaciente || "--")}</span>
            </div>
            <div class="ecografia-field-row">
              <span class="ecografia-field-label">Med Solicitante:</span>
              <span class="ecografia-field-value">${escapeForTemplate(medicoSolicitante)}</span>
            </div>
            <div class="ecografia-field-row">
              <span class="ecografia-field-label">Cobertura:</span>
              <span class="ecografia-field-value">${escapeForTemplate(coberturaPaciente)}</span>
            </div>
          </div>
          <div class="ecografia-grid-col">
            <div class="ecografia-field-row">
              <span class="ecografia-field-label">Edad:</span>
              <span class="ecografia-field-value">${escapeForTemplate(edadPaciente)}</span>
            </div>
            <div class="ecografia-field-row">
              <span class="ecografia-field-label">Fecha:</span>
              <span class="ecografia-field-value">${escapeForTemplate(fechaEstudio)}</span>
            </div>
            <div class="ecografia-field-row">
              <span class="ecografia-field-label">N° Estudio:</span>
              <span class="ecografia-field-value">${escapeForTemplate(numeroEstudio)}</span>
            </div>
          </div>
        </div>
        <div class="ecografia-midline"></div>
        <p class="ecografia-title">${escapeForTemplate(tituloInforme || "ECOGRAFÍA")}</p>
        <div class="ecografia-title-underline"></div>
        <div class="ecografia-content">
          ${htmlContent}
        </div>
        <div class="ecografia-footer">
          <span>Documento generado desde Portal Pacientes</span>
          <span>Emitido: ${escapeForTemplate(fechaGeneracion)}</span>
        </div>
      </div>
    `;

    document.body.appendChild(container);

    try {
      const imagenes = Array.from(container.querySelectorAll("img"));
      await Promise.all(
        imagenes.map(
          (img) =>
            new Promise((resolve) => {
              if (img.complete) {
                resolve();
                return;
              }

              img.onload = () => resolve();
              img.onerror = () => resolve();
              setTimeout(resolve, 1200);
            }),
        ),
      );

      const canvas = await html2canvas(container, {
        scale: 2,
        backgroundColor: "#ffffff",
        useCORS: true,
      });

      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const margin = 10;
      const printableWidth = pageWidth - margin * 2;
      const printableHeight = pageHeight - margin * 2;
      const imageHeight = (canvas.height * printableWidth) / canvas.width;

      let heightLeft = imageHeight;
      let positionY = margin;

      pdf.addImage(
        imgData,
        "PNG",
        margin,
        positionY,
        printableWidth,
        imageHeight,
        undefined,
        "FAST",
      );
      heightLeft -= printableHeight;

      while (heightLeft > 0) {
        pdf.addPage();
        positionY = margin - (imageHeight - heightLeft);
        pdf.addImage(
          imgData,
          "PNG",
          margin,
          positionY,
          printableWidth,
          imageHeight,
          undefined,
          "FAST",
        );
        heightLeft -= printableHeight;
      }

      return createPdfPayload(
        new Uint8Array(pdf.output("arraybuffer")),
        "ecografia generada en el navegador",
      );
    } catch (error) {
      console.error("No se pudo generar el PDF de ecografía:", error);
      return null;
    } finally {
      if (container.parentNode) {
        container.parentNode.removeChild(container);
      }
    }
  };

  const visualizarEcografiaDesdeRtf = async ({
    rtf,
    nombre,
    fecha,
    esEcografiaArchivo = false,
  }) => {
    const htmlContent = getRtfHtmlContent(rtf);

    setEstudioPdf({
      fecha: fecha || "Sin fecha",
      nombre: nombre || "Ecografía",
      doc: rtf,
      esEcografia: true,
      esEcografiaArchivo,
      ecografiaHtml: htmlContent || "",
      ecografiaPdfUrl: "",
      generandoPdfEcografia: Boolean(htmlContent),
      pdfFile: null,
      pdfBlobUrl: "",
    });
    abrirModalEstudio();

    if (!htmlContent) return;

    const pdfPayload = await generarPdfDesdeHtmlEcografia(
      htmlContent,
      nombre,
      fecha,
    );

    setEstudioPdf((prev) => {
      if (!prev?.esEcografia || prev.doc !== rtf) {
        if (pdfPayload?.pdfBlobUrl) {
          URL.revokeObjectURL(pdfPayload.pdfBlobUrl);
        }
        return prev;
      }

      return {
        ...prev,
        ...(pdfPayload || {}),
        ecografiaPdfUrl: pdfPayload?.pdfBlobUrl || "",
        generandoPdfEcografia: false,
      };
    });
  };

  const descargarPdfGeneradoEcografia = (pdfUrl, nombre, fecha) => {
    if (!pdfUrl) return;

    const nombreSanitizado = `${nombre || "Ecografia"}-${fecha || "SinFecha"}`
      .replace(/[\\/:*?"<>|]/g, "_")
      .replace(/\s+/g, " ")
      .trim();

    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = `${nombreSanitizado}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const extractCodigoEcografiaFromNombre = (nombreArchivo = "") => {
    if (!nombreArchivo) return null;

    const matchFin = nombreArchivo.match(/(\d+)(?=\.[^.]+$|$)/);
    if (matchFin?.[1]) return matchFin[1];

    const todosLosNumeros = nombreArchivo.match(/\d+/g);
    return todosLosNumeros?.length
      ? todosLosNumeros[todosLosNumeros.length - 1]
      : null;
  };

  const getTipoArchivo = (nombreArchivo) => {
    let partes = nombreArchivo.split(".");
    let tipo = partes.at(-1)?.toLowerCase();
    if (
      tipo &&
      ["pdf", "jpg", "jpeg", "png", "bmp", "gif", "rtf"].includes(tipo)
    )
      return tipo;
    else return null;
  };

  const traerEstudiosPaciente = async (paciente) => {
    let estudios = [];
    const url = localStorage.getItem("urlAxioPP");

    try {
      const responseCarpeta1 = await fetchJsonFromCandidates({
        debugLabel: "listado colpos carpeta 1",
        token: paciente.token,
        candidateUrls: [
          buildApiUrl(url, "EstudiosImagenes/TraerNombresArchivos", {
            documentoNro: paciente.documentoNro,
            carpeta: 1,
          }),
          buildApiUrl(url, "EstudiosPacientes/TraerNombresArchivos", {
            documentoNro: paciente.documentoNro,
            carpeta: 1,
          }),
        ],
      });

      const responseCarpeta2 = await fetchJsonFromCandidates({
        debugLabel: "listado histeroscopias carpeta 2",
        token: paciente.token,
        candidateUrls: [
          buildApiUrl(url, "EstudiosImagenes/TraerNombresArchivos", {
            documentoNro: paciente.documentoNro,
            carpeta: 2,
          }),
          buildApiUrl(url, "EstudiosPacientes/TraerNombresArchivos", {
            documentoNro: paciente.documentoNro,
            carpeta: 2,
          }),
        ],
      });

      const responsePatologias = await fetchJsonFromCandidates({
        debugLabel: "listado patologias",
        token: paciente.token,
        candidateUrls: [
          buildApiUrl(url, "EstudiosImagenes/TraerPatologia", {
            DocumentoPaciente: paciente.documentoNro,
          }),
          buildApiUrl(url, "EstudiosPacientes/TraerPatologia", {
            DocumentoPaciente: paciente.documentoNro,
          }),
        ],
      });

      const responseEcografiasArchivos = await fetchJsonFromCandidates({
        debugLabel: "listado ecografias carpeta 3",
        token: paciente.token,
        candidateUrls: [
          buildApiUrl(url, "EstudiosImagenes/TraerNombresArchivos", {
            documentoNro: paciente.documentoNro,
            carpeta: 3,
          }),
          buildApiUrl(url, "EstudiosPacientes/TraerNombresArchivos", {
            documentoNro: paciente.documentoNro,
            carpeta: 3,
          }),
        ],
      });

      const responseEcografiasDetalle = await fetchJsonFromCandidates({
        debugLabel: "detalle ecografias",
        token: paciente.token,
        candidateUrls: [
          buildApiUrl(url, "EstudiosImagenes/TraerEcografiaPaciente", {
            paciente: paciente.codigo,
          }),
          buildApiUrl(url, "EstudiosPacientes/TraerEcografiaPaciente", {
            paciente: paciente.codigo,
          }),
        ],
      });

      // Combinar estudios de ambas carpetas y patologías
      if (responseCarpeta1.data && responseCarpeta1.data.length > 0) {
        estudios = estudios.concat(
          responseCarpeta1.data.map((estudio) => ({
            ...estudio,
            carpeta: 1,
            tipoEstudio: "Colposcopia",
          })),
        );
      }
      if (responseCarpeta2.data && responseCarpeta2.data.length > 0) {
        estudios = estudios.concat(
          responseCarpeta2.data.map((estudio) => ({
            ...estudio,
            carpeta: 2,
            tipoEstudio: "Histeroscopia",
          })),
        );
      }
      // NUEVO: Agregar patologías desde base de datos
      if (responsePatologias.data && responsePatologias.data.length > 0) {
        // Ordenar patologías por fecha descendente (más reciente primero)
        const patologiasOrdenadas = responsePatologias.data.sort((a, b) => {
          const fechaA = new Date(a.fecha);
          const fechaB = new Date(b.fecha);
          return fechaB - fechaA; // Orden descendente
        });

        estudios = estudios.concat(
          patologiasOrdenadas.map((patologia) => ({
            ...patologia,
            carpeta: 3, // Carpeta virtual para patologías
            tipoEstudio: "Patología",
            esPatologia: true, // Flag para identificar que viene de BD
            fechaModificacion: null, // Las patologías usan el campo 'fecha' directamente del endpoint
          })),
        );
      }

      // Agregar ecografías desde archivos (carpeta 3) y desde el detalle.
      // No todos los informes del detalle tienen un archivo asociado: si se
      // consulta solo la carpeta 3, esos estudios quedan fuera de la UI.
      const hayEcografiasArchivos = Boolean(
        responseEcografiasArchivos.data?.length,
      );
      const hayEcografiasDetalle = Boolean(
        responseEcografiasDetalle.data?.length,
      );

      if (hayEcografiasArchivos) {
        const mapaDetallesEcografia = new Map();
        if (hayEcografiasDetalle) {
          responseEcografiasDetalle.data.forEach((detalle) => {
            if (detalle?.codigo) {
              mapaDetallesEcografia.set(String(detalle.codigo), detalle);
            }
          });
        }

        const ecografiasMapeadas = responseEcografiasArchivos.data.map(
          (archivo) => {
            const codigo = extractCodigoEcografiaFromNombre(archivo.nombre);
            const detalleEcografia = codigo
              ? mapaDetallesEcografia.get(String(codigo))
              : null;
            const fechaOriginal = detalleEcografia?.fecha || null;
            return {
              ...archivo,
              carpeta: 3,
              tipoEstudio: "Ecografía",
              esEcografiaArchivo: true,
              fechaOriginal,
              documentoRtf: detalleEcografia?.documento || null,
            };
          },
        );

        const ecografiasOrdenadas = ecografiasMapeadas.sort((a, b) => {
          const fechaA = new Date(
            a.fechaOriginal || a.fechaModificacion || a.fechaCreacion || 0,
          );
          const fechaB = new Date(
            b.fechaOriginal || b.fechaModificacion || b.fechaCreacion || 0,
          );
          return fechaB - fechaA;
        });

        estudios = estudios.concat(ecografiasOrdenadas);

        // Incorporar informes que no tienen archivo en la carpeta 3. Los que
        // sí lo tienen ya fueron agregados arriba como ecografías de archivo.
        const codigosEnArchivos = new Set(
          ecografiasMapeadas
            .map((ecografia) =>
              extractCodigoEcografiaFromNombre(ecografia.nombre),
            )
            .filter(Boolean)
            .map(String),
        );
        const ecografiasSinArchivo = responseEcografiasDetalle.data.filter(
          (ecografia) => !codigosEnArchivos.has(String(ecografia.codigo)),
        );

        estudios = estudios.concat(
          ecografiasSinArchivo.map((ecografia) => ({
            ...ecografia,
            carpeta: 4,
            tipoEstudio: "Ecografía",
            esEcografia: true,
            fechaModificacion: null,
          })),
        );
      } else if (hayEcografiasDetalle) {
        const ecografiasOrdenadas = responseEcografiasDetalle.data.sort(
          (a, b) => {
            const fechaA = new Date(a.fecha || 0);
            const fechaB = new Date(b.fecha || 0);
            return fechaB - fechaA;
          },
        );

        estudios = estudios.concat(
          ecografiasOrdenadas.map((ecografia) => ({
            ...ecografia,
            carpeta: 4,
            tipoEstudio: "Ecografía",
            esEcografia: true,
            fechaModificacion: null,
          })),
        );
      }

      // NUEVO: Consultar Laboratorio desde nueva API de LACE
      let responseLaboratorio = { data: null };
      try {
        const urlLace = `https://resultados.cloudlablace.com.ar:4443/gateway/integracion-api/v1/report?DocumentTypeId=1&DocumentNumber=${paciente.documentoNro}`;
        responseLaboratorio = await axios.get(urlLace, config);

        // Verificar si la respuesta es exitosa y tiene informes
        if (
          responseLaboratorio.data &&
          (responseLaboratorio.data.estado === "ok" ||
            responseLaboratorio.data.estado === "Ok") &&
          responseLaboratorio.data.informes &&
          responseLaboratorio.data.informes.length > 0
        ) {
          console.log(
            "Laboratorios encontrados para DNI:",
            paciente.documentoNro,
            "- Informes:",
            responseLaboratorio.data.informes.length,
          );

          // Verificar si todos los informes son iguales (mismo base64)
          const informesUnicos = [];
          const base64Vistos = new Set();

          responseLaboratorio.data.informes.forEach((informe, index) => {
            // Usar los primeros 100 caracteres del base64 como identificador único
            const identificadorBase64 = informe.informeBase64
              ? informe.informeBase64.substring(0, 100)
              : "";

            if (
              !base64Vistos.has(identificadorBase64) &&
              informe.informeBase64
            ) {
              base64Vistos.add(identificadorBase64);
              informesUnicos.push(informe);
            }
          });

          console.log(
            "Informes únicos encontrados:",
            informesUnicos.length,
            "de",
            responseLaboratorio.data.informes.length,
            "totales",
          );

          // Agregar solo informes únicos al array de estudios
          const informesLaboratorio = informesUnicos.map((informe, index) => ({
            nombre:
              informesUnicos.length > 1
                ? `Informe de Laboratorio ${index + 1}`
                : "Informe de Laboratorio",
            codigo: `LAB${index + 1}`,
            carpeta: 5, // Carpeta virtual para laboratorio
            tipoEstudio: "Laboratorio",
            esLaboratorio: true,
            fechaModificacion: null,
            documentoNro: paciente.documentoNro,
            informeBase64: informe.informeBase64,
            extension: informe.extension,
            fechaInforme: informe.fecha || "Sin fecha",
          }));

          estudios = estudios.concat(informesLaboratorio);
        } else {
          console.log(
            "No se encontraron estudios de laboratorio para DNI:",
            paciente.documentoNro,
          );

          try {
            const responseSinHeaders = await axios.get(urlLace);

            if (
              responseSinHeaders.data &&
              (responseSinHeaders.data.estado === "ok" ||
                responseSinHeaders.data.estado === "Ok") &&
              responseSinHeaders.data.informes &&
              responseSinHeaders.data.informes.length > 0
            ) {
              responseLaboratorio = responseSinHeaders;

              // Verificar si todos los informes son iguales (mismo base64) - Fallback
              const informesUnicos = [];
              const base64Vistos = new Set();

              responseLaboratorio.data.informes.forEach((informe, index) => {
                const identificadorBase64 = informe.informeBase64
                  ? informe.informeBase64.substring(0, 100)
                  : "";

                if (
                  !base64Vistos.has(identificadorBase64) &&
                  informe.informeBase64
                ) {
                  base64Vistos.add(identificadorBase64);
                  informesUnicos.push(informe);
                }
              });

              const informesLaboratorio = informesUnicos.map(
                (informe, index) => ({
                  nombre:
                    informesUnicos.length > 1
                      ? `Informe de Laboratorio ${index + 1}`
                      : "Informe de Laboratorio",
                  codigo: `LAB${index + 1}`,
                  carpeta: 5,
                  tipoEstudio: "Laboratorio",
                  esLaboratorio: true,
                  fechaModificacion: null,
                  documentoNro: paciente.documentoNro,
                  informeBase64: informe.informeBase64,
                  extension: informe.extension,
                  fechaInforme: informe.fecha || "Sin fecha",
                }),
              );

              estudios = estudios.concat(informesLaboratorio);
            }
          } catch (errorSinHeaders) {}
        }
      } catch (laboratorioError) {
        console.warn("Error al cargar laboratorios:", laboratorioError.message);
        // Si hay error, no mostrar laboratorio
        responseLaboratorio = { data: null };
      }

      estudios = estudios.map((estudio, i) => {
        // NUEVO: Procesamiento específico para Laboratorio
        if (estudio.esLaboratorio) {
          // Formatear la fecha si tiene 8 dígitos, sino mostrar el string tal cual
          let fechaFormateada = "No disponible";
          if (estudio.fechaInforme) {
            const fechaStr = estudio.fechaInforme;
            if (/^\d{8}$/.test(fechaStr)) {
              fechaFormateada = `${fechaStr.substr(0, 2)}/${fechaStr.substr(
                2,
                2,
              )}/${fechaStr.substr(4, 4)}`;
            } else {
              fechaFormateada = fechaStr;
            }
          }

          return {
            ...estudio,
            codigoUI: i,
            fecha: fechaFormateada,
            text: estudio.nombre || "Informe de Laboratorio",
            tipoEstudio: "Laboratorio",
            formato: estudio.extension || "pdf",
          };
        }

        // NUEVO: Procesamiento específico para patologías
        if (estudio.esPatologia) {
          // Formatear fecha de patología si existe
          let fechaFormateada = "No disponible";
          if (estudio.fecha) {
            // La fecha viene en formato ISO "2021-01-15T00:00:00", formatear a DD/MM/YYYY
            fechaFormateada = dayjs(estudio.fecha).format("DD/MM/YYYY");
          }

          return {
            ...estudio,
            codigoUI: i, // Índice para UI/rendering
            fecha: fechaFormateada, // Usar la fecha del endpoint
            text: estudio.nombre
              ? estudio.nombre.replace(".pdf", "").replace(".PDF", "")
              : "Patología",
            tipoEstudio: "Patología",
            formato: getTipoArchivo(estudio.nombre) || "pdf", // Asumir PDF si no se puede determinar
          };
        }

        // NUEVO: Procesamiento específico para ecografías (archivos carpeta 3)
        if (estudio.esEcografiaArchivo) {
          let fechaFormateada = "No disponible";
          const fechaEcografia =
            estudio.fechaOriginal ||
            estudio.fechaModificacion ||
            estudio.fechaCreacion;
          if (fechaEcografia) {
            fechaFormateada = dayjs(fechaEcografia).format("DD/MM/YYYY");
          }

          let nombreEcografia = estudio.nombre || "Ecografía";
          nombreEcografia = nombreEcografia.replace(/\.[^.]+$/, "");

          return {
            ...estudio,
            codigoUI: i,
            fecha: fechaFormateada,
            text: nombreEcografia,
            tipoEstudio: "Ecografía",
            formato: getTipoArchivo(estudio.nombre) || "pdf",
          };
        }

        // Fallback: ecografías del endpoint viejo (RTF)
        if (estudio.esEcografia) {
          let fechaFormateada = "No disponible";
          if (estudio.fecha) {
            fechaFormateada = dayjs(estudio.fecha).format("DD/MM/YYYY");
          }

          return {
            ...estudio,
            codigoUI: i,
            fecha: fechaFormateada,
            text: estudio.nombre || "Ecografía",
            tipoEstudio: "Ecografía",
            formato: "rtf",
          };
        }

        // Procesamiento existente para colpos e histeroscopias
        let nombre = estudio.nombre;
        nombre = nombre.replace(`${paciente.documentoNro}_`, "");
        nombre = nombre.replace(".pdf", "");
        nombre = nombre.replace(".pdf", "");

        let fechaParaMostrar;
        if (estudio.fechaModificacion) {
          fechaParaMostrar = dayjs(estudio.fechaModificacion).format(
            "DD/MM/YYYY",
          );
        } else {
          // Fallback: intentar extraer fecha del nombre si no existe fechaModificacion
          let fecha = dayjs(
            new Date(
              Number(nombre.substr(-8, 4)),
              Number(nombre.substr(-4, 2)) - 1,
              Number(nombre.substr(-2, 2)),
            ),
          );
          fechaParaMostrar = fecha.isValid()
            ? fecha.format("DD/MM/YYYY")
            : "No disponible";
        }

        // Lógica original para el nombre del estudio (sin cambios)
        let fecha = dayjs(
          new Date(
            Number(nombre.substr(-8, 4)),
            Number(nombre.substr(-4, 2)) - 1,
            Number(nombre.substr(-2, 2)),
          ),
        );

        if (
          fecha.isValid() &&
          (fecha.isBefore(dayjs()) || dayjs().isSame(fecha))
        ) {
          return {
            ...estudio,
            codigo: i, // Para colpos/histeros, codigo sigue siendo el índice
            codigoUI: i, // Consistencia con patologías
            fecha: fechaParaMostrar, // CAMBIO: Usar la fecha de fechaModificacion
            text: nombre.substr(
              0,
              nombre.substr(-11, 3) === " - "
                ? nombre.length - 11
                : nombre.length - 8,
            ),
            carpeta: estudio.carpeta,
            tipoEstudio: estudio.tipoEstudio,
            formato: getTipoArchivo(estudio.nombre),
          };
        } else {
          return {
            ...estudio,
            codigo: i, // Para colpos/histeros, codigo sigue siendo el índice
            codigoUI: i, // Consistencia con patologías
            fecha: fechaParaMostrar, // CAMBIO: Usar la fecha de fechaModificacion
            text: nombre,
            carpeta: estudio.carpeta,
            tipoEstudio: estudio.tipoEstudio,
            formato: getTipoArchivo(estudio.nombre),
          };
        }
      });

      // Las ecografías pueden provenir de archivos o del detalle RTF. Una vez
      // normalizadas, se ordenan juntas para que el informe más reciente quede
      // primero, independientemente de su origen.
      const fechaEcografiaOrdenable = (fecha) => {
        const [dia, mes, anio] = String(fecha || "").split("/");
        const fechaNormalizada = new Date(anio, Number(mes) - 1, dia);
        return Number.isNaN(fechaNormalizada.getTime())
          ? 0
          : fechaNormalizada.getTime();
      };
      estudios.sort((a, b) => {
        if (a.tipoEstudio !== "Ecografía" || b.tipoEstudio !== "Ecografía") {
          return 0;
        }
        return fechaEcografiaOrdenable(b.fecha) - fechaEcografiaOrdenable(a.fecha);
      });

      setListadoEstudios(estudios);
      setListadoEstudiosFiltrados(estudios);
      // setListadoEstudiosFiltro(estudios); // COMENTADO - estado no utilizado
    } catch (error) {
      mostrarNotificacion(
        true,
        "Error: " + (error.response?.data || error.message),
        "rojo",
      );
    }
  };

  const BuscarEstudio = async (estudio, pdfDoc, pdfUrl) => {
    try {
      let response;

      if (estudio.esLaboratorio) {
        if (estudio.informeBase64) {
          const pdfPayload = createPdfPayload(
            base64ToUint8Array(estudio.informeBase64),
            "informe de laboratorio base64",
          );
          setEstudioPdf({
            fecha: estudio.fecha || "Sin fecha",
            nombre: estudio.text || "Informe de Laboratorio",
            doc: null,
            esLaboratorio: true,
            ...pdfPayload,
          });
          abrirModalEstudio();
        } else {
          mostrarNotificacion(
            true,
            "No se pudo cargar el informe de laboratorio",
            "rojo",
          );
        }
        return;
      }

      if (estudio.esEcografia) {
        await visualizarEcografiaDesdeRtf({
          rtf: estudio.documento,
          nombre: estudio.nombre,
          fecha: estudio.fecha || "Sin fecha",
        });
        return;
      }

      if (estudio.esEcografiaArchivo) {
        if (!pdfDoc && pdfUrl && estudio.documentoRtf) {
          await visualizarEcografiaDesdeRtf({
            rtf: estudio.documentoRtf,
            nombre: estudio.text || estudio.nombre || "Ecografía",
            fecha: estudio.fecha || "Sin fecha",
            esEcografiaArchivo: true,
          });
          return;
        }

        response = await fetchBlobFromCandidates({
          debugLabel: `ecografia archivo ${estudio.nombre || ""}`.trim(),
          token: usuario.token,
          candidateUrls: [
            buildApiUrl(urlAxioPP, "EstudiosImagenes/DescargarImagenes", {
              documentoNro: usuario.documentoNro,
              nombreArchivo: estudio.nombre,
              carpeta: 3,
            }),
            buildApiUrl(
              urlAxioPP,
              "EstudiosPacientes/DescargarCospoImagenes",
              {
                documentoNro: usuario.documentoNro,
                nombreArchivo: estudio.nombre,
                carpeta: 3,
              },
            ),
          ],
        });
      }

      if (estudio.esPatologia) {
        response = await fetchBlobFromCandidates({
          debugLabel: `patologia ${estudio.nombre || estudio.codigo || ""}`.trim(),
          token: usuario.token,
          candidateUrls: [
            buildApiUrl(urlAxioPP, "EstudiosImagenes/DescargarPatologia", {
              codigo: estudio.codigo,
            }),
            buildApiUrl(urlAxioPP, "EstudiosPacientes/DescargarPatologia", {
              codigo: estudio.codigo,
            }),
          ],
        });
      } else if (!estudio.esEcografiaArchivo) {
        response = await fetchBlobFromCandidates({
          debugLabel: `estudio carpeta ${estudio.carpeta} ${estudio.nombre || ""}`.trim(),
          token: usuario.token,
          candidateUrls: [
            buildApiUrl(urlAxioPP, "EstudiosImagenes/DescargarImagenes", {
              documentoNro: usuario.documentoNro,
              nombreArchivo: estudio.nombre,
              carpeta: estudio.carpeta,
            }),
            buildApiUrl(urlAxioPP, "EstudiosPacientes/DescargarCospoImagenes", {
              documentoNro: usuario.documentoNro,
              nombreArchivo: estudio.nombre,
              carpeta: estudio.carpeta,
            }),
          ],
        });
      }

      if (response.data.size > 0) {
        if (pdfDoc && !pdfUrl) {
          const file = new Blob([response.data], {
            type: response.data.type || "application/octet-stream",
          });
          const fileURL = URL.createObjectURL(file);

          const fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.download = `${estudio.text}.${estudio.formato}`;
          fileLink.click();
          setTimeout(() => URL.revokeObjectURL(fileURL), 1000);
        } else {
          // Visualización
          if (!pdfDoc && pdfUrl && estudio.esEcografiaArchivo) {
            try {
              const contenidoTexto = await response.data.text();
              const textoNormalizado = contenidoTexto
                ?.replace(/\u0000/g, "")
                ?.trimStart();
              const pareceRtf =
                /^\{\\rtf/i.test(textoNormalizado) ||
                /\\pard\b|\\line\b|\\u-?\d+\s*\??/i.test(textoNormalizado);

              if (pareceRtf) {
                await visualizarEcografiaDesdeRtf({
                  rtf: textoNormalizado,
                  nombre: estudio.text || estudio.nombre || "Ecografía",
                  fecha: estudio.fecha || "Sin fecha",
                  esEcografiaArchivo: true,
                });
                return;
              }
            } catch (errorLecturaRtf) {
              console.warn(
                "No se pudo leer el blob de ecografía como texto RTF:",
                errorLecturaRtf,
              );
            }
          }

          if (!pdfDoc && pdfUrl) {
            const responseBytes = new Uint8Array(
              await response.data.arrayBuffer(),
            );
            const pdfPayload = createPdfPayload(
              responseBytes,
              `API de estudios (${response.data.type || "MIME no informado"})`,
            );
            setEstudioPdf({
              fecha: estudio.fecha,
              nombre: estudio.text,
              doc: null,
              formato: estudio.formato,
              esEcografiaArchivo: estudio.esEcografiaArchivo,
              ...pdfPayload,
            });
            abrirModalEstudio();
          }
        }
      }
    } catch (error) {
      mostrarNotificacion(
        true,
        "Ha ocurrido un error al intentar buscar el estudio seleccionado: " +
          (error.response?.status || error.message),
        "rojo",
      );
    }

    return null;
  };

  const descargarEcografiaDesdeRtf = async (estudio) => {
    const htmlContent = getRtfHtmlContent(estudio.documento);
    if (!htmlContent) {
      mostrarNotificacion(
        true,
        "No se pudo generar el PDF de la ecografía",
        "rojo",
      );
      return;
    }

    const pdfPayload = await generarPdfDesdeHtmlEcografia(
      htmlContent,
      estudio.text || estudio.nombre,
      estudio.fecha,
    );
    if (!pdfPayload?.pdfBlobUrl) {
      mostrarNotificacion(
        true,
        "No se pudo generar el PDF de la ecografía",
        "rojo",
      );
      return;
    }

    descargarPdfGeneradoEcografia(
      pdfPayload.pdfBlobUrl,
      estudio.text || estudio.nombre,
      estudio.fecha,
    );
    setTimeout(() => URL.revokeObjectURL(pdfPayload.pdfBlobUrl), 1000);
  };

  const DescargarPdf = async (estudio) => {
    setCargando(true);
    try {
      if (estudio?.esEcografia) {
        await descargarEcografiaDesdeRtf(estudio);
      } else if (estudio) {
        await BuscarEstudio(estudio, true, false);
      } else {
        mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
      }
    } finally {
      setCargando(false);
    }
  };

  const VisualizarPdf = async (estudio) => {
    setCargando(true);
    try {
      if (estudio) {
        if (estudio.esLaboratorio) {
          await BuscarEstudio(estudio, false, false);
        } else {
          await BuscarEstudio(estudio, false, true);
        }
      } else {
        mostrarNotificacion(true, "Estudio sin archivo guardado", "rojo");
      }
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    let activo = true;

    const cargarEstudios = async () => {
      if (!activo) return;
      setCargandoEstudios(true);
      try {
        const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
        if (sesion) {
          await traerEstudiosPaciente(sesion);
          setUsuario(sesion);
          setUrlAxio(localStorage.getItem("urlAxioPP"));
          setTituloPagina(localStorage.getItem("nombreClinica"));
          document.title = localStorage.getItem("tituloWeb");
        }
      } catch (e) {
        history.push({ pathname: "/ErrorPage" });
      } finally {
        if (activo) setCargandoEstudios(false);
      }
    };

    cargarEstudios();

    return () => {
      activo = false;
    };
  }, []);

  useEffect(() => {
    const currentPdfUrl = estudioPdf?.pdfBlobUrl;
    return () => {
      if (
        currentPdfUrl &&
        typeof currentPdfUrl === "string" &&
        currentPdfUrl.startsWith("blob:")
      ) {
        URL.revokeObjectURL(currentPdfUrl);
      }
    };
  }, [estudioPdf?.pdfBlobUrl]);

  //cosas para el modal
  const [numPages, setNumPages] = React.useState(null);
  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  const renderPdfEmbed = (pdfFile, title, pdfBlobUrl) => {
    if (!pdfFile) return null;
    const horizontalPadding = window.innerWidth <= 480 ? 20 : 48;
    const pageWidth = Math.max(
      240,
      Math.min((window.innerWidth || 1280) - horizontalPadding, 1100),
    );

    return (
      <div
        className="viewer-pdfjs-container"
        role="document"
        aria-label={title}
      >
        <Document
          key={pdfBlobUrl}
          file={pdfFile}
          onLoadSuccess={onDocumentLoadSuccess}
          loading={<div className="viewer-loading">Cargando PDF...</div>}
          error={
            <div className="viewer-error">
              <h3>No se pudo visualizar el PDF.</h3>
              <p>
                El archivo es un PDF valido, pero no se pudo renderizar dentro
                del visor. Puede abrirlo o descargarlo para verlo completo.
              </p>
              {pdfBlobUrl && (
                <StyledButton
                  strong={true}
                  onClick={() => abrirEnNuevaVentana(pdfBlobUrl)}
                  className="amarillo-sol"
                >
                  Abrir PDF
                </StyledButton>
              )}
            </div>
          }
        >
          <div className="viewer-pdfjs-pages">
            {Array.from(new Array(numPages || 0), (_, index) => (
              <div key={`pdf-page-${index + 1}`} className="viewer-pdfjs-page">
                <Page
                  pageNumber={index + 1}
                  width={pageWidth}
                  renderAnnotationLayer={false}
                  renderTextLayer={true}
                />
              </div>
            ))}
          </div>
        </Document>
      </div>
    );
  };

  return (
    <>
      {!cargandoEstudios && listadoEstudios.length <= 0 ? (
        <IonGrid>
          <IonRow className="ion-justify-content-center">
            <IonCol>
              <div className="ion-text-center">
                <p>No tiene estudios registrados aun</p>
              </div>
            </IonCol>
          </IonRow>
        </IonGrid>
      ) : (
        <>
          {/* NUEVA VERSIÓN - Diseño Card-Based Moderno CON ACCORDION */}
          <div style={{ padding: "16px", backgroundColor: "#f8f9fa" }}>
            {Object.entries(
              listadoEstudiosFiltrados.reduce((acc, estudio) => {
                const tipo = estudio.tipoEstudio;
                if (!acc[tipo]) {
                  acc[tipo] = [];
                }
                acc[tipo].push(estudio);
                return acc;
              }, {}),
            ).map(([tipoEstudio, estudios]) => {
              // Definir colores por tipo de estudio
              const getEstudioColor = (tipo) => {
                const colores = {
                  Histeroscopia: {
                    primary: "#6366f1",
                    secondary: "#e0e7ff",
                    icon: "🔬",
                  },
                  Patología: {
                    primary: "#f59e0b",
                    secondary: "#fef3c7",
                    icon: "📋",
                  },
                  Ecografía: {
                    primary: "#10b981",
                    secondary: "#d1fae5",
                    icon: "📡",
                  },
                  Laboratorio: {
                    primary: "#ef4444",
                    secondary: "#fee2e2",
                    icon: "🧪",
                  },
                  Colposcopia: {
                    primary: "#8b5cf6",
                    secondary: "#f3e8ff",
                    icon: "🔍",
                  },
                };
                return (
                  colores[tipo] || {
                    primary: "#64748b",
                    secondary: "#f1f5f9",
                    icon: "📄",
                  }
                );
              };

              const colorConfig = getEstudioColor(tipoEstudio);

              return (
                <AccordionGroup
                  key={tipoEstudio}
                  variant="plain"
                  sx={{ marginBottom: "24px" }}
                >
                  <Accordion
                    variant="plain"
                    sx={{
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      borderRadius: "12px",
                      overflow: "hidden",
                      backgroundColor: "white",
                    }}
                  >
                    {/* Header del tipo de estudio como AccordionSummary */}
                    <AccordionSummary
                      sx={{
                        background: `linear-gradient(135deg, ${colorConfig.primary} 0%, ${colorConfig.primary}dd 100%)`,
                        color: "white",
                        padding: "16px 20px",
                        minHeight: "72px",
                        "&:hover": {
                          background: `linear-gradient(135deg, ${colorConfig.primary}ee 0%, ${colorConfig.primary}cc 100%)`,
                        },
                        "& .MuiAccordionSummary-button": {
                          cursor: "pointer",
                        },
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "12px",
                          width: "100%",
                        }}
                      >
                        <span style={{ fontSize: "24px" }}>
                          {colorConfig.icon}
                        </span>
                        <Typography
                          level="title-lg"
                          sx={{ color: "white", fontWeight: 600, flex: 1 }}
                        >
                          {tipoEstudio}
                        </Typography>
                        <div
                          style={{
                            backgroundColor: "rgba(255,255,255,0.2)",
                            borderRadius: "16px",
                            padding: "4px 12px",
                            fontSize: "14px",
                            fontWeight: "500",
                          }}
                        >
                          {estudios.length}{" "}
                          {estudios.length === 1 ? "estudio" : "estudios"}
                        </div>
                      </div>
                    </AccordionSummary>

                    {/* Lista de estudios como AccordionDetails */}
                    <AccordionDetails sx={{ padding: 0 }}>
                      <div
                        style={{
                          backgroundColor: "white",
                        }}
                      >
                        {estudios.map((estudio, index) => (
                          <div
                            key={estudio.codigoUI || estudio.codigo}
                            style={{
                              padding: "20px",
                              borderBottom:
                                index < estudios.length - 1
                                  ? `1px solid ${colorConfig.secondary}`
                                  : "none",
                              display: "flex",
                              alignItems: "center",
                              gap: "16px",
                              transition: "all 0.2s ease",
                              cursor: "pointer",
                            }}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor =
                                colorConfig.secondary;
                              e.currentTarget.style.transform =
                                "translateX(4px)";
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = "white";
                              e.currentTarget.style.transform = "translateX(0)";
                            }}
                          >
                            {/* Indicador visual */}
                            <div
                              style={{
                                width: "4px",
                                height: "48px",
                                backgroundColor: colorConfig.primary,
                                borderRadius: "2px",
                                flexShrink: 0,
                              }}
                            />

                            {/* Contenido del estudio */}
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <Typography
                                level="title-sm"
                                sx={{
                                  color: "#1f2937",
                                  fontWeight: 600,
                                  marginBottom: "4px",
                                  display: "block",
                                }}
                              >
                                {estudio.text.length > 25
                                  ? estudio.text.substring(0, 25) + "..."
                                  : estudio.text}
                              </Typography>
                              <Typography
                                level="body-xs"
                                sx={{
                                  color: "#6b7280",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "8px",
                                }}
                              >
                                📅 {estudio.fecha}
                                {estudio.formato && (
                                  <span
                                    style={{
                                      backgroundColor: colorConfig.secondary,
                                      color: colorConfig.primary,
                                      padding: "2px 8px",
                                      borderRadius: "12px",
                                      fontSize: "11px",
                                      fontWeight: "500",
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    {estudio.formato}
                                  </span>
                                )}
                              </Typography>
                            </div>

                            {/* Acciones */}
                            <div
                              style={{
                                display: "flex",
                                gap: "8px",
                                flexShrink: 0,
                              }}
                            >
                              <Tooltip title="Visualizar" arrow placement="top">
                                <div
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    VisualizarPdf(estudio);
                                  }}
                                  style={{
                                    width: "40px",
                                    height: "40px",
                                    borderRadius: "50%",
                                    backgroundColor: colorConfig.primary,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    transition: "all 0.2s ease",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.transform =
                                      "scale(1.1)";
                                    e.currentTarget.style.boxShadow =
                                      "0 4px 12px rgba(0,0,0,0.2)";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.transform =
                                      "scale(1)";
                                    e.currentTarget.style.boxShadow =
                                      "0 2px 8px rgba(0,0,0,0.1)";
                                  }}
                                >
                                  <VisibilityIcon
                                    sx={{ color: "white", fontSize: "20px" }}
                                  />
                                </div>
                              </Tooltip>

                              {!estudio.esLaboratorio && (
                                  <Tooltip
                                    title="Descargar"
                                    arrow
                                    placement="top"
                                  >
                                    <div
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        DescargarPdf(estudio);
                                      }}
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                        backgroundColor: "#64748b",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        cursor: "pointer",
                                        transition: "all 0.2s ease",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.transform =
                                          "scale(1.1)";
                                        e.currentTarget.style.backgroundColor =
                                          "#475569";
                                        e.currentTarget.style.boxShadow =
                                          "0 4px 12px rgba(0,0,0,0.2)";
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.transform =
                                          "scale(1)";
                                        e.currentTarget.style.backgroundColor =
                                          "#64748b";
                                        e.currentTarget.style.boxShadow =
                                          "0 2px 8px rgba(0,0,0,0.1)";
                                      }}
                                    >
                                      <DownloadIcon
                                        sx={{
                                          color: "white",
                                          fontSize: "20px",
                                        }}
                                      />
                                    </div>
                                  </Tooltip>
                                )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </AccordionDetails>
                  </Accordion>
                </AccordionGroup>
              );
            })}
          </div>

          {abrirModal && (
            <div
              className="viewer-overlay"
              role="dialog"
              aria-modal="true"
              aria-label={`${estudioPdf.nombre} - ${estudioPdf.fecha}`}
            >
              <div
                className={`viewer-panel ${
                  estudioPdf.esEcografia
                    ? "viewer-panel-ecografia"
                    : "viewer-panel-pdf"
                }`}
              >
                <div className="viewer-panel-header">
                  <div className="viewer-panel-title">{`${estudioPdf.nombre} - ${estudioPdf.fecha}`}</div>
                  <div className="viewer-panel-actions">
                    {Boolean(estudioPdf.pdfBlobUrl) && (
                      <StyledButton
                        fill="clear"
                        onClick={() =>
                          abrirEnNuevaVentana(estudioPdf.pdfBlobUrl)
                        }
                        className="amarillo-sol-text"
                        style={{ fontSize: "14px" }}
                      >
                        🔍 Ampliar
                      </StyledButton>
                    )}
                    {Boolean(estudioPdf.ecografiaPdfUrl) && (
                      <StyledButton
                        fill="clear"
                        onClick={() =>
                          descargarPdfGeneradoEcografia(
                            estudioPdf.ecografiaPdfUrl,
                            estudioPdf.nombre,
                            estudioPdf.fecha,
                          )
                        }
                        className="amarillo-sol-text"
                        style={{ fontSize: "14px" }}
                      >
                        Descargar PDF
                      </StyledButton>
                    )}
                    <StyledButton
                      strong={true}
                      onClick={() => cerrarModalEstudio()}
                      fill="clear"
                      className="amarillo-sol-text"
                    >
                      Cerrar
                    </StyledButton>
                  </div>
                </div>
                <div className="viewer-panel-body">
                  {estudioPdf.esLaboratorio ? (
                    <>
                      {renderPdfEmbed(
                        estudioPdf.pdfFile,
                        "Informe de Laboratorio",
                        estudioPdf.pdfBlobUrl,
                      )}
                      <div
                        className="viewer-zoom-indicator"
                        onClick={() =>
                          abrirEnNuevaVentana(estudioPdf.pdfBlobUrl)
                        }
                        title="Click para ver a pantalla completa"
                      >
                        🔍 Click para ampliar
                      </div>
                    </>
                  ) : estudioPdf.esEcografia ? (
                    estudioPdf.ecografiaPdfUrl ? (
                      <>
                        {renderPdfEmbed(
                          estudioPdf.pdfFile,
                          `${estudioPdf.nombre} - ${estudioPdf.fecha}`,
                          estudioPdf.pdfBlobUrl,
                        )}
                        <div
                          className="viewer-zoom-indicator"
                          onClick={() =>
                            abrirEnNuevaVentana(estudioPdf.pdfBlobUrl)
                          }
                          title="Click para ver a pantalla completa"
                        >
                          🔍 Click para ampliar
                        </div>
                      </>
                    ) : (
                      <div className="viewer-text-content">
                        {estudioPdf.generandoPdfEcografia && (
                          <div className="viewer-generating-pdf">
                            Generando PDF del informe...
                          </div>
                        )}
                        {estudioPdf.ecografiaHtml
                          ? parse(estudioPdf.ecografiaHtml)
                          : parseRtfToHtml(estudioPdf.doc)}
                      </div>
                    )
                  ) : (
                    estudioPdf.pdfFile && (
                      <>
                        {renderPdfEmbed(
                          estudioPdf.pdfFile,
                          `${estudioPdf.nombre} - ${estudioPdf.fecha}`,
                          estudioPdf.pdfBlobUrl,
                        )}
                        <div
                          className="viewer-zoom-indicator"
                          onClick={() =>
                            abrirEnNuevaVentana(estudioPdf.pdfBlobUrl)
                          }
                          title="Click para ver a pantalla completa"
                        >
                          🔍 Click para ampliar
                        </div>
                      </>
                    )
                  )}
                </div>
              </div>
            </div>
          )}
          <CustomToast
            openToast={toast.open}
            onDidDismiss={(e) => mostrarNotificacion(false, "", "")}
            message={toast.mensaje}
            colorNotificacion={toast.tipo}
          />
        </>
      )}
      {(cargando || cargandoEstudios) && (
        <LoadingBackdrop
          visualizar={cargando || cargandoEstudios}
          texto={cargandoEstudios ? "Cargando..." : "Cargando..."}
        />
      )}
    </>
  );
}
